var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftPic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RightPic Arrow Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5202759,12.4527268 L17.2961528,7.62665853 C17.4276571,7.49409268 17.5,7.31684875 17.5,7.12785851 C17.5,6.93876336 17.4276571,6.76162434 17.2961528,6.62884876 L16.8776642,6.20619019 C16.7463676,6.07320487 16.5708556,6 16.3838227,6 C16.1967899,6 16.0214855,6.07320487 15.890085,6.20619019 L10.2036424,11.952039 C10.0717229,12.0852341 9.99948384,12.2632122 10.0000028,12.4524122 C9.99948384,12.6424513 10.0716191,12.8202195 10.2036424,12.9535195 L15.8847916,18.6938098 C16.0161921,18.8267951 16.1914965,18.9 16.3786332,18.9 C16.565666,18.9 16.7409704,18.8267951 16.8724746,18.6938098 L17.2908595,18.2711512 C17.5631054,17.9960561 17.5631054,17.5482269 17.2908595,17.2732366 L12.5202759,12.4527268 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RightPic-Arrow-Copy",
    transform: "translate(13.000000, 13.000000) scale(-1, 1) translate(-13.000000, -13.000000) "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fillOpacity: 0.3,
    fill: "#A5A5A5",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(13.750000, 12.450000) scale(-1, 1) translate(-13.750000, -12.450000) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftPic);
export default __webpack_public_path__ + "static/media/arrowLeftPic.d4e566d0c296ed070bd137ea22e7523c.svg";
export { ForwardRef as ReactComponent };